
import TableList from "@components/templates/tablelist";
import {
    HttpGetWarehouseOfflineList,
    HttpOrgServiceWarehouseList,
    HttpGetAllCarrierService,
    HttpAddOfflineOrder,
    HttpUpdateStatus
} from "@/service/basicdata.js";
import compUpdate from "./update.vue";
export default {
    mixins: [TableList],
    components: {
        compUpdate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 120,
            },
            Plugins: { show: true },
            initData: '',
            warehouseList: [],
            carrierServiceList: []
        };
    },
    created() {
        HttpOrgServiceWarehouseList().then(res => {
            this.warehouseList = (res.data || []).map(item => {
                return {
                    value: item.id,
                    label: `${item.code}(${item.title})`
                }
            });
        }, err => {
            this.$VMessage.error(err.message);
        });
        HttpGetAllCarrierService().then(res => {
            this.carrierServiceList = res.data.map(item => {
                return {
                    label: `${item.carrierServiceName}(${item.carrierServiceCode})`,
                    value: item.id,
                    attach: {
                        carrierServiceCode: item.carrierServiceCode
                    }
                }
            });
        }, err => {
            this.$VMessage.error(err.message);
        });
    },
    methods: {
        ajaxRequest: HttpGetWarehouseOfflineList,
        exportQuery() {
            let searchData = {}
            Object.keys(this.formData.search).map(item => {
                searchData[`search[${item}]`] = this.formData.search[item]
            });
            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/offlineOrder/batchExport", {
                ...searchData
            }, {
                executor: 'request',
                download: true,
            }).catch(err => {
                this.$VMessage.error(err.message);
            })
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.selectdata', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'exportQuery':
                    this.exportQuery(params)
                    break;
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 800,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case 'add':
                    this.operate = {
                        title: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                        show: true,
                        width: 600,
                        alert: "success",
                        showDesc: false,
                        formdata: [
                            {
                                label: "仓库",
                                key: "warehouseId",
                                tag: "vSelect",
                                span: 24,
                                options: this.warehouseList,
                                props: {
                                    filterable: true
                                },
                                required: true
                            },
                            {
                                label: "承运商服务",
                                key: "carrierServiceId",
                                tag: "vSelect",
                                span: 24,
                                options: this.carrierServiceList,
                                props: {
                                    filterable: true,
                                },
                                required: true
                            }
                        ],
                        ajaxRequest: HttpAddOfflineOrder,
                    }
                    break;
                case "active":
                    this.operate = {
                        show: true,
                        title: "启用",
                        alert: "primary",
                        params: {
                            id: params
                        },
                        ajaxRequest: HttpUpdateStatus,
                    };
                    break;
                case "disable":
                    this.operate = {
                        show: true,
                        title: "失效",
                        alert: "warning",
                        params: {
                            id: params
                        },
                        ajaxRequest: HttpUpdateStatus,
                    };
                    break;
                case "import":
                    this.operate = {
                        show: true,
                        title: '导入',
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/offlineOrder/importOrder",
                        name: "multipartFile",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/offlineOrder/itemTemplate", {}, 'download');
                        },
                        on: {
                            "on-success": () => {
                                this.$emit('on-close');
                                this.$emit('on-update');
                            }
                        }
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: true,
                    params: id,
                    operate: "query"
                },
                {
                    label: "失效",
                    show: row.active == 0,
                    params: id,
                    operate: "disable"
                },
                {
                    label: "启用",
                    show: row.active == 1,
                    params: id,
                    operate: "active"
                }
            ]
        },
    },
    computed: {
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    show: this.handleAuth('fbb.offlineorder.add'),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "导入",
                    show: this.handleAuth('fbb.offlineorder.add'),
                    operate: "import",
                    theme: "success"
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    show: this.handleAuth('fbb.offlineorder.export'),
                    operate: 'exportQuery',
                    theme: 'default'
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'IN_warehouseId',
                    show: true,
                    tag: 'Select',
                    options: this.warehouseList,
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    }
                },
                {
                    label: "承运商服务",
                    tag: 'Select',
                    show: true,
                    key: 'IN_carrierServiceId',
                    options: this.carrierServiceList,
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    }
                },
                {
                    label: "是否线下订单",
                    key: "EQ_active",
                    tag: "vSelect",
                    show: true,
                    options: [
                        { value: 0, label: '是' },
                        { value: 1, label: '否' }
                    ],
                },
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                }, {
                    title: "仓库",
                    render: (h, { row }) => {
                        let warehouseItem = this.warehouseList.filter(item => {
                            return item.value === row.warehouseId
                        })[0];
                        return <div>{warehouseItem ? warehouseItem.label : '--'}</div>
                    }
                },
                {
                    title: "承运商服务",
                    render: (h, { row }) => {
                        let carrierItem = this.carrierServiceList.filter(item => {
                            return item.value === row.carrierServiceId
                        })[0];
                        return <div>{carrierItem ? carrierItem.label : '--'}</div>
                    }
                },
                {
                    title: "是否线下订单",
                    key: 'active',
                    render: (h, { row }) => {
                        let font = row.active ? '否' : '是';
                        return <div>{font}</div>
                    }
                },
                {
                    title: "更新时间",
                    key: 'updatedAt'
                }
            ];
        },

    }

};
